import { createAction } from 'redux-actions';

import types from './types';

const initialize = createAction(types.INITIALIZE);
const loadDeliveryModes = createAction(types.LOAD_DELIVERY_MODES);
const setDeliveryMode = createAction(types.SET_DELIVERY_MODE);
const setDeliveryModes = createAction(types.SET_DELIVERY_MODES);
const setDeliveryBlocked = createAction(types.SET_DELIVERY_BLOCKED);
const setDeliveryModeOnPaymentStep = createAction(types.SET_DELIVERY_MODE_ON_PAYMENT_STEP);
const setCheckRts = createAction(types.SET_CHECK_RTS);
const setRtsAvailable = createAction(types.SET_RTS_AVAILABLE);
const setRtsUnreachableMsg = createAction(types.SET_RTS_UNREACHABLE_MSG);
const setShowRtsUnreachableMsg = createAction(types.SET_SHOW_RTS_UNREACHABLE_MSG);
const openDialogGWPDeliveryMethodConfirmation = createAction(
    types.OPEN_DIALOG_GWP_DELIVERY_METHOD_CONFIRMATION,
);

export default {
    initialize,
    loadDeliveryModes,
    setDeliveryModes,
    setDeliveryMode,
    setDeliveryBlocked,
    setDeliveryModeOnPaymentStep,
    setCheckRts,
    setRtsAvailable,
    setRtsUnreachableMsg,
    setShowRtsUnreachableMsg,
    openDialogGWPDeliveryMethodConfirmation,
};
